const PENDING_FORMULA_KEY = "salary_v2_pending_component_formula";

export function parseComponentToolSearchParams(searchParams) {
  const componentId = searchParams.get("componentId") || "";
  const componentCode = searchParams.get("code") || "";
  const returnTo = searchParams.get("returnTo") || "";
  return {
    componentId: componentId.trim(),
    componentCode: componentCode.trim(),
    returnTo: returnTo.trim(),
  };
}

export function componentEditPath(componentId) {
  if (!componentId) return "/salary-v2/components";
  return `/salary-v2/components/${componentId}/edit`;
}

export function buildFormulaBuilderPath({ componentId, componentCode, returnTo, expression } = {}) {
  const params = new URLSearchParams();
  if (componentId) params.set("componentId", String(componentId));
  if (componentCode) params.set("code", String(componentCode));
  if (returnTo) params.set("returnTo", returnTo);
  if (expression) params.set("expression", expression);
  const q = params.toString();
  return `/salary-v2/formula-builder${q ? `?${q}` : ""}`;
}

export function buildDerivedVariablesPath({ componentId, componentCode, returnTo } = {}) {
  const params = new URLSearchParams();
  if (componentId) params.set("componentId", String(componentId));
  if (componentCode) params.set("code", String(componentCode));
  if (returnTo) params.set("returnTo", returnTo);
  const q = params.toString();
  return `/salary-v2/derived-variables${q ? `?${q}` : ""}`;
}

export function stashPendingComponentFormula({ componentId, expression }) {
  if (!componentId || !String(expression || "").trim()) return;
  try {
    sessionStorage.setItem(
      PENDING_FORMULA_KEY,
      JSON.stringify({
        componentId: String(componentId),
        expression: String(expression).trim(),
        ts: Date.now(),
      }),
    );
  } catch {
    /* ignore */
  }
}

export function consumePendingComponentFormula(componentId) {
  if (!componentId) return null;
  try {
    const raw = sessionStorage.getItem(PENDING_FORMULA_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (String(data?.componentId) !== String(componentId)) return null;
    sessionStorage.removeItem(PENDING_FORMULA_KEY);
    return String(data.expression || "").trim() || null;
  } catch {
    return null;
  }
}

export function applyFormulaToComponentAndReturn(navigate, { componentId, expression, returnTo }) {
  const expr = String(expression || "").trim();
  const path = returnTo || componentEditPath(componentId);
  if (!expr || !componentId) {
    navigate(path);
    return;
  }
  stashPendingComponentFormula({ componentId, expression: expr });
  navigate(path, { state: { formulaExpression: expr } });
}
